// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import {
	ALL_SECTIONS, COLORS, FORM_DATA, FORM_SECTIONS
} from './utils/constants';

export const MainAppContext = React.createContext();

function MainApp({ children }) {
	const [portal, setPortal] = React.useState();
	const [colors, setColors] = React.useState();
	const [routing, setRouting] = React.useState();
	const [openMobileMenu, setOpenMobileMenu] = React.useState();
	const [lastRoute, setLastRoute] = React.useState();
	const [showRoutingPopUp, setShowRoutingPopUp] = React.useState(false);
	const [formDataIni, setFormDataIni] = React.useState();
	const [formData, setFormData] = React.useState();

	React.useEffect(() => {
		if (portal?.config?.defaultVoteSense?.custom) {
			setFormDataIni({
				...FORM_DATA,
				votes: Object.values(portal?.config?.defaultVoteSense?.custom)
			});
			setFormData({
				...FORM_DATA,
				votes: Object.values(portal?.config?.defaultVoteSense?.custom)
			});
		} else {
			setFormDataIni(FORM_DATA);
			setFormData(FORM_DATA);
		}
	}, [portal !== undefined]);

	const clearFormDataIni = () => {
		const { language } = formData;
		setFormDataIni({
			...formDataIni,
			language
		});
	};

	const clearFormData = () => {
		clearFormDataIni();
		setFormData({
			...formDataIni,
		});
	};

	/* If home section is active, go home, if not, look for any that is active */
	React.useEffect(() => {
		if (!portal?.config?.sections?.home?.isActive) {
			Object.values(portal?.config?.sections || [])
				?.some(section => {
					if (section.isActive) {
						setRouting(section.value);
					}
					return section.isActive;
				});
			return;
		}
		setRouting('home');
	}, [portal?.config?.sections]);

	/* Update color */
	React.useEffect(() => {
		setColors(portal?.config?.theme?.colors || COLORS);
	}, [portal?.config?.theme?.colors]);

	let hasChanges = false;

	hasChanges = () => JSON.stringify(formData) !== JSON.stringify(formDataIni);


	const updateRouting = route => {
		if (routing === route) {
			return;
		}
		if (FORM_SECTIONS.includes(routing) && formData && hasChanges(formData)) {
			setShowRoutingPopUp(true);
			setLastRoute(route);
			return;
		}
		if (ALL_SECTIONS.includes(route)) {
			setRouting(route);
			return;
		}
		setRouting(null);
	};

	const confirmRoute = () => {
		setRouting(lastRoute);
		setLastRoute();
		setShowRoutingPopUp(false);
	};

	const cancelRoute = () => {
		setLastRoute();
		setShowRoutingPopUp(false);
	};

	/* Memoized value to avoid rerender */
	const providerValue = React.useMemo(() => ({
		portal,
		setPortal,
		colors,
		routing,
		updateRouting,
		formData,
		setFormData,
		formDataIni,
		setFormDataIni,
		clearFormData,
		showRoutingPopUp,
		setShowRoutingPopUp,
		confirmRoute,
		cancelRoute,
		openMobileMenu,
		setOpenMobileMenu,
	}), [portal, colors, routing, formData, formDataIni, openMobileMenu, showRoutingPopUp]);

	return (
		<MainAppContext.Provider value={providerValue}>
			{children}
		</MainAppContext.Provider>
	);
}

export default MainApp;
